// Author liang gang qiang
// Date 2021-11-22 17:18:29

import * as model from "@/model/mintalMes/prd/MintalMesPrdProductionResultModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdProductionResult(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'pelletizingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'smeltingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'pelletizingEntity',
        entityConstructor: model.MintalMesPrdProductionResult
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'smeltingEntity',
        entityConstructor: model.MintalMesPrdProductionResult
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'pelletizingVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'smeltingVo'
    })
    .buildStore()
